import YFooter from './src/main'

YFooter.install = function(Vue) {
  Vue.component(YFooter.name, YFooter)
}

export default YFooter
